import Repository from '@/repositories';
const UsersRepository = Repository.get('users');
import i18n from '../../i18n';

export const namespaced = true;

export const state = {
  config: null,
  loadingUserConfig: false,
};

export const mutations = {
  setUserConfig(state, newValue) {
    state.config = newValue;
    i18n.locale = newValue.language;
  },
  setLoadingUserConfig(state, newValue) {
    state.loadingUserConfig = newValue;
  },
  setUserAppVersion(state) {
    state.config.lastSeenVersion = state.config.currentAppVersion;
  },
};

export const actions = {
  fetchUserConfig({ commit }, idPublic) {
    return UsersRepository.customREST
      .getWithConfig(idPublic)
      .then((response) => {
        let config = response.data;
        commit('setUserConfig', config);
        return config;
      })
      .catch(() => {
        console.error('GET USER CONFIG ERROR'); // eslint-disable-line
      });
  },
  updateUserLanguage({ state, commit, dispatch, rootState }, language) {
    let newValue = { ...state.config, language: language };
    commit('setUserConfig', newValue);

    dispatch(
      'cache/setOrganizationConfig',
      rootState.cache.organizationConfig,
      { root: true }
    );

    //Not waiting for the update because it's low priority saving the language. In worst case it will be wrong during the next session.
    UsersRepository.update(newValue, newValue.idPublic).catch(() => {
      console.error('UPDATE LANGUAGE ERROR'); // eslint-disable-line
    });
  },
  updateUserAppVersion({ commit }) {
    commit('setUserAppVersion');
  },
};
